export default {
    BASE_URL: 'https://api.restaurant-libanais-adonis.com/',
    SITE_BASE_URL: 'https://www.restaurant-libanais-adonis.com/',
}